import { type SiteResponse } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { Link } from '@on3/ui-lib/components/Link';
import { useSite } from '@on3/ui-lib/src/contexts/SiteProvider';
import { getAssetUrl } from '@on3/ui-lib/utils/images';
import { SidebarWrapper } from 'components/UI/Layout/Containers/Sidebar/SidebarWrapper';

import styles from './SidebarTeamContainer.module.scss';

interface ISidebarTeamContainerProps {
  children: React.ReactNode;
  siteData?: SiteResponse | null;
}

export const SidebarTeamContainer = ({
  children,
  siteData,
}: ISidebarTeamContainerProps) => {
  const { currentSite } = useSite();
  const site = siteData || currentSite;
  const isKsrChannel = currentSite?.url === '/college/kentucky-wildcats';
  const siteLink = isKsrChannel
    ? `/sites/${currentSite?.slug}/`
    : currentSite?.isTeam
      ? `/college/${currentSite?.slug}/`
      : `/teams/${currentSite?.slug}/`;

  const orgName =
    currentSite?.organization?.knownAs ?? currentSite?.organization?.name ?? '';
  const siteLogoUrl = getAssetUrl(site.alternateLogo) || '';

  return (
    <SidebarWrapper>
      {currentSite?.isChannel && (
        <>
          <Link href={siteLink}>
            <img
              alt={orgName}
              className={styles.logo}
              height={30}
              src={siteLogoUrl}
              title={orgName}
              width={255}
            />
          </Link>
          <h2 className={styles.firstLine}>
            News From{' '}
            <Link href={siteLink} useSiteColor>
              {currentSite?.siteName}
            </Link>
          </h2>
        </>
      )}
      {!currentSite?.isChannel && (
        <>
          <Link href={siteLink}>
            <Avatar
              className={styles.logo}
              domain={currentSite?.organization?.defaultAssetRes?.domain}
              height={30}
              source={currentSite?.organization?.defaultAssetRes?.source}
              teamAvatar
              title={currentSite?.organization?.name}
              type={currentSite?.organization?.defaultAssetRes?.type}
              width={30}
            />
          </Link>
          <Link href={siteLink} useSiteColor>
            <h2 className={styles.firstLine}>{orgName} News</h2>
          </Link>
          <p className={styles.secondLine}>From On3 National</p>
        </>
      )}
      {children}
    </SidebarWrapper>
  );
};
